import { useEffect } from 'react'
import { useAvatarStore } from '@/shared/store/avatar-store'

interface UseAvatarLoadingManagerParams {
  onAvatarLoaded: (loaded: boolean) => void
}

/**
 * 아바타 로딩 상태 관리 Hook
 *
 * 책임:
 * - Three.js 앱 로딩 상태 감지
 * - 타임아웃 fallback 처리 (10초)
 * - 로딩 완료 콜백 호출
 */
export const useAvatarLoadingManager = ({ onAvatarLoaded }: UseAvatarLoadingManagerParams) => {
  const isThreejsAppReady = useAvatarStore(state => state.isThreejsAppReady)

  // Three.js 앱이 준비되면 콜백 호출
  useEffect(() => {
    if (isThreejsAppReady) {
      onAvatarLoaded(true)
    }
  }, [isThreejsAppReady, onAvatarLoaded])

  // 타임아웃 fallback: 10초 후에도 로딩이 안되면 강제로 진입 가능하게
  useEffect(() => {
    const timeout = setTimeout(() => {
      console.warn('⚠️ 아바타 로딩 타임아웃 - 강제 진입 허용')
      onAvatarLoaded(true)
    }, 10000)

    return () => clearTimeout(timeout)
  }, [onAvatarLoaded])

  return {
    isThreejsAppReady
  }
}
